// extracted by mini-css-extract-plugin
export default {"reychat_edited_message_subtitle":"styles_reychat_edited_message_subtitle__5Vx5Q"};